module.exports = __webpack_public_path__ + "img/write-2.61781d4e.svg";